<template>
    <main class="pd-main">
      <div class="main-content">
        <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
        <div class="row" v-else> 
          <div class="col-xl-8">
            <div class="card">
                <h4 class="card-title"><strong>ALL CAMPUS CLUBS</strong></h4>
                <div class="card-body">
                  <v-client-table :columns="columns" :data="data" :options="options"> 
                        <div slot="id" slot-scope="props" >{{props.index}}</div>
                        <div slot="actions" slot-scope="props">
                          <nav class="flexbox fs-16">
                            <a href="#" @click="delAction(props.row.id)" data-provide="tooltip" data-original-title="Delete">
                              <span class="btn btn-sm btn-danger icon ion-android-delete"></span>
                            </a>
                          </nav>
                        </div>
                  </v-client-table>
                </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4" v-if="!open_form">
              <div class="card">
                <h4 class="card-title"><strong>NEW CAMPUS CLUB</strong></h4>
                <div class="card-body">
                  <div class="py-30 text-center">
                    <div class="pb-10">
                      <h5> Add clubs for different campuses</h5>
                      <p class="mb-10">Make sure to fill the correct registration link to join the club.</p>
                    </div>
                    <a class="btn btn-sm btn-round btn-primary" href="#" @click="openForm">Add New</a>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-lg-6 col-xl-4" v-else>
              <div class="card">
                <h4 class="card-title"><strong>ADD NEW CAMPUS CLUB</strong></h4>
                <div class="card-body">
                    <div class="form-group">
                      <label>Name of School</label>
                      <input class="form-control" type="text" id="school" @blur="$v.school.$touch()" v-model="school"/>
                      <div v-if="$v.school.$dirty">
                        <div class="custom-error" v-if="!$v.school.required">*School name is required.</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Club Registration URL</label>
                      <input class="form-control" type="text" id="link" @blur="$v.link.$touch()" v-model="link"/>
                      <div v-if="$v.link.$dirty">
                        <div class="custom-error" v-if="!$v.link.required">*A link is required.</div>
                      </div>
                    </div>
                    <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loading">
                      <circle-spin class="m-0"></circle-spin>
                    </button>
                    <button class="mb-10 btn btn-sm btn-bold btn-primary" href="#" v-else :disabled="$v.$invalid" @click="addClub" type="button">Add Club</button>
                </div>
              </div>
          </div>
        </div>

        <!-- Modal for delete -->
            <modal name="delete-action" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-error py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideDeleteModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5>Delete Campus Club</h5>
                        <div class="p-10">
                            <p>Are you sure you want to delete this club?</p>
                            <button class="btn btn-bold btn-sm btn-danger" disabled v-if="load_delete">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-danger" v-else type="button" @click="deleteAction">Delete</button>
                        </div>
                    </div>
                </div> 
            </modal>
      </div>
    </main>
</template>


<script>
import axios from 'axios'
import {
  required,
  email
} from "vuelidate/lib/validators";

export default {
    data() {
        return {
            open_form: false,
            firstLoad: true,
            loading: false,
            school: "",
            link: "https://",
            position: "",
            open_form: false,
            columns: ["id", "school", "email", 'actions'],
            data: [],
            options: {
              headings: {
                id: "S/N",
                school: "School Name",
                email: "Club link",
                actions: "Actions"
              },
              sortable: ["school"],
              filterable: ["school"]
            },
            id: null,
            load_delete: false
        }
    },
    validations: {
      school: { required },
      link: {
        required
      }
    },
    methods: {
        openForm() {
            this.open_form = true
        },
        addClub() {
          this.loading = true
          let userData = {
              school: this.school,
              email: this.link
            };
            axios.post('/admin/add?type=club', userData)
            .then(res => {
              // console.log(res)
              this.loading = false;
              this.$notify({
                group: 'response',
                type: 'success',
                title: 'Successfully added new club',
                duration: 2500
              });
              setTimeout(() => {
                location.reload()
              }, 3000)
            })
            .catch(err => {
              this.loading = false;
              this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
              });
            })
        },
        delAction(id) {
          this.id = id
          this.$modal.show("delete-action");
        },
        hideDeleteModal(a) {
            a.hide('delete-action')
        },
        deleteAction() {
          this.load_delete = true
          let userData = {
                    id: this.id
                }
                axios.delete(`/admin/delete?type=club&id=${this.id}`)
                .then(res => {
                    this.load_delete = false
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'Successfully deleted.',
                            duration: 2500,
                        })
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                })
                .catch(err => {
                    this.load_delete= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
        }
      },
      mounted() {
        axios.get("/admin/list?type=campus_club").then(res => {
          this.firstLoad = false;
          return (this.data = res.data.data);
        })
        .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
      }
}
</script>
